<template>
  <div id="main">
    <div class="wrapper" v-if="$store.state.isLoggedIn">
      <template v-if="$store.state.isLoggedIn">
        <app-header @onTrigger="drawer = !drawer"></app-header>
        <v-navigation-drawer id="sidebar_menu" fixed v-model="drawer" dark app class="menu primary">
          <v-layout>
            <v-flex>
              <v-btn fab flat dark small @click="onGoHome">
                <v-icon>home</v-icon>
              </v-btn>
            </v-flex>
            <v-flex class="text-xs-right">
              <v-btn fab flat dark small @click="drawer = false" class="hidden-sm-and-up">
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>

          <div class="text-xs-center">
            <div class="mb-2 white--text" style="text-transform: capitalize;">
              {{ $store.state.userid }}
            </div>
            <div class="avatar mb-4">
              <div class="avatar-img" style="position: relative;">
                <div style="position: absolute; right: -5px; top: -5px;">
                  <template
                    v-if="
                      !selectedBot.pagerole ||
                        (selectedBot.pagerole && selectedBot.pagerole == 'admin')
                    "
                  ></template>
                </div>
                <v-avatar size="100px">
                  <img
                    class="responsive-img circle"
                    style="min-width: 100%"
                    alt
                    @error="onError"
                    :src="
                      'https://graph.facebook.com/' +
                        selectedBot.pageid +
                        '/picture?width=100&height=100'
                    "
                    :class="{
                      'bot-active': selectedBot.status,
                      'bot-inactive': !selectedBot.status
                    }"
                  />
                </v-avatar>
              </div>
            </div>

            <div style="margin-bottom: 15px;">
              <div class="status active" v-if="selectedBot.status">
                <v-icon small>play_arrow</v-icon>
                <span style="margin-left: 5px;">{{ $t('active') }}</span>
              </div>
              <div class="status inactive" v-else>
                <v-icon small>pause</v-icon>
                <span style="margin-left: 5px;">{{ $t('inactive') }}</span>
              </div>
            </div>

            <v-btn round outline class="select-page-list" dark small>
              <div
                class="text-truncate"
                style="display:inline-block; word-break: break-all;max-width: 150px;    vertical-align: middle;"
              >
                {{ selectedBot.pagename }}
              </div>
            </v-btn>
          </div>

          <div class="mt-4">
            <div>
              <ul class="menu-list">
                <!-- <router-link :to="'/' + $i18n.locale() + '/conversation'">
                  <li tabindex="0" class="icon-speech">
                    <span>{{ $t('Conversation') }}</span>
                  </li>
                </router-link> -->
                <router-link :to="'/' + $i18n.locale() + '/flow'">
                  <li tabindex="0" class="icon-flow">
                    <span>{{ $t('Flow') }}</span>
                  </li>
                </router-link>

                <router-link :to="'/' + $i18n.locale() + '/analytic'">
                  <li tabindex="0" class="icon-analytics">
                    <span>{{ $t('analytics') }}</span>
                  </li>
                </router-link>
                <router-link :to="'/' + $i18n.locale() + '/broadcast'">
                  <li tabindex="0" class="icon-megaphone">
                    <span>{{ $t('Broadcast') }}</span>
                  </li>
                </router-link>
                <router-link :to="'/' + $i18n.locale() + '/interventioncatalog'">
                  <li tabindex="0" class="icon-flow">
                    <span>{{ $t('Intervention Catalog') }}</span>
                  </li>
                </router-link>
                <li
                  tabindex="0"
                  class="icon-sign-out"
                  @click="logout"
                  :data-intro="
                    $t('Click here, if your setting is finished or if you want to sigh out.')
                  "
                >
                  <span>{{ $t('Sign Out') }}</span>
                </li>
              </ul>
            </div>
          </div>
        </v-navigation-drawer>
        <v-content>
          <flash-message class="myCustomClass" :transitionName="'slide-fade'"></flash-message>
          <slot></slot>
        </v-content>
        <app-footer />
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import header from '@/components/elements/header'
import footer from '@/components/elements/footer'
import dropdown from 'vue-dropdowns'
import moment from 'moment'

import api from '@/api'

import 'intro.js/minified/introjs.min.css'

export default {
  // name: "dashboard",
  components: {
    'app-header': header,
    'app-footer': footer,
    dropdown
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: 'botlist',
      isSelectedBot: 'isSelectedBot',
      isFacebook: 'isFacebook',
      currentLang: 'currentLang',
      showModalWelcome: 'showModalWelcome'
    }),
    showAlertLine: function() {
      if (this.$store.getters.showAlert('line') >= 0) {
        var alert = this.$store.getters.showAlert('line')
        return alert.show
      } else {
        return true
      }
    },
    showAlertExpiredPackage: function() {
      if (this.$store.getters.showAlert('expriedPackage') >= 0) {
        var alert = this.$store.getters.showAlert('expriedPackage')
        return alert.show
      } else {
        return true
      }
    },
    optionBotlist: function() {
      let options = []
      let vm = this
      $.each(vm.botlist, function(index, val) {
        if (val.pageid != vm.selectedBot.pageid) {
          options.push({ name: val.pagename, value: val.pageid })
        }
      })

      return options
    },
    filterBotlist: function() {}
  },
  data: function() {
    return {
      drawer: null,
      autostart: false,
      introConfig: {
        nextLabel: this.$t('Next'),
        prevLabel: this.$t('Back'),
        skipLabel: this.$t('skip'),
        doneLabel: this.$t('Finish')
      },
      myOptions: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: 'Skip tour',
          buttonPrevious: 'Previous',
          buttonNext: 'Next',
          buttonStop: 'Finish'
        }
      },
      showMenu: false,
      x: 0,
      y: 0,
      currentBot: null,
      pagelist: [],
      selectedOption: {},
      expriedTime: null,
      expriedDate: null
    }
  },
  mounted: function() {
    var vm = this
    // vm.$store.dispatch('addModalWelcome')

    var now = moment()
    var expriedDate = moment(this.$store.state.selectedBot.expireat)
    this.expriedDate = parseInt(expriedDate.diff(now, 'days'))
    this.expriedTime = parseInt(expriedDate.diff(now, 'seconds'))

    vm.selectedOption = {
      name: vm.selectedBot.pagename,
      value: vm.selectedBot.pageid
    }
    vm.getSetting(function(contents) {
      vm.$store.dispatch('updateSetting', contents)
    })

    // this.$tours['myTour'].start()

    if (vm.showModalWelcome) {
      // vm.openTutorial()
    }
  },
  created: function() {
    var vm = this
    vm.$validator.localize(vm.currentLang)
  },
  methods: {
    onGoHome() {
      location.href = '/' + this.$i18n.locale() + '/allbots'
    },
    openTutorial: function() {
      var vm = this
      vm.$nextTick(function() {
        vm.showMenu = true
        setTimeout(() => {
          const introJS = require('intro.js')
          introJS
            .introJs()
            .setOption('nextLabel', vm.$t('Next'))
            .setOption('prevLabel', vm.$t('Back'))
            .setOption('skipLabel', vm.$t('skip'))
            .setOption('doneLabel', vm.$t('Finish'))
            .setOption('showBullets', false)
            .start()
        }, 1000)
      })
    },
    logout: function() {
      var vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to Logout?'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            var isFacebook = vm.isFacebook
            vm.$store.dispatch('logout', null).then()
            vm.$router.push('/' + vm.currentLang + '/login')
          }
        })
    },
    selectBot: function(page) {
      var vm = this
      vm.$store.dispatch('loading')
      $.each(vm.botlist, function(index, bot) {
        if (page.value === bot.pageid) {
          vm.$store.dispatch('selectBot', bot)
        }
      })
      location.reload()
    },
    onError: function(event) {
      $(event.target).attr('src', '/static/img/assets/livechat/profile.png')
    },
    show(e) {
      e.preventDefault()
      this.showMenu = false
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showMenu = true
      })
    },
    getSetting: function(callback) {
      let vm = this
      var data = {
        pageid: vm.$store.state.selectedBot.pageid
      }

      api.getSetting(data, function(error, response) {
        if (error) {
          console.error(error)
          return
        }

        var contents = {}
        $.each(response.data, function(index, val) {
          contents[val.contenttype] = val
        })
        callback(contents)
      })
    },
    getWelcomeMessage: function(callback) {
      let vm = this
      // vm.$store.dispatch('loading')
      let data = {
        pageid: vm.selectedBot.pageid
      }

      var message = null
      var generics = [
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: true
        }
      ]
      var messages = null
      var type = 'json'
      api.getWelcomeMessage(data, function(error, response) {
        if (error) {
          console.error(error)
          return
        }
        if (response.data) {
          type = response.data.type
          if (type === 'message') {
            messages = [
              [
                {
                  text: response.data.message_text,
                  type: 'text'
                }
              ]
            ]
          } else if (type === 'generic') {
            messages = [[]]
            if (
              response.data.message &&
              typeof response.data.message === 'object' &&
              response.data.message.length > 0
            ) {
              $.each(response.data.message, function(index, val) {
                generics[index] = val
              })

              messages[0][0] = {
                type: 'generic',
                data: generics
              }
            }
          } else {
            if (vm.isJsonParseable(response.data.message)) {
              messages = JSON.parse(response.data.message)
            }
          }
          type = 'json'
        }
        callback({
          type: type,
          message: message,
          generics: generics,
          messages: messages
        })
      })
    },
    toggleBotStatus: function() {
      let vm = this
      let bot = Object.assign({}, vm.selectedBot)
      bot.status = !bot.status

      let in_status_label = bot.status ? 'stop' : 'start'
      vm.$store.dispatch('loading')
      api.toggleBotStatus(bot, function(error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
          return
        }

        let newbotlist = vm.botlist
        $.each(newbotlist, function(index, oldbot) {
          if (bot.pageid == oldbot.pageid) {
            newbotlist[index].status = bot.status
            return false
          }
        })
        // console.log(bot)
        vm.botStatus = bot.status
        vm.$store.dispatch('selectBot', bot)
        vm.$store.dispatch('updateBotlist', newbotlist)
        vm.$store.dispatch('loading')
      })
    }
  }
}
</script>

<style lang="scss" scroped>
.menu {
  .avatar {
    .bot-active {
      border: 3px solid #a0e83d;
    }

    .bot-inactive {
      border: 3px solid red;
    }
  }

  ul.menu-list {
    list-style: none;
    padding: 0.5em 0;
    margin: 0;

    .router-link-active {
      li {
        background-color: rgba(255, 255, 255, 0.2);
      }
    }

    a {
      text-decoration: none;
    }
    li {
      font-size: 0.95em;
      font-weight: 300;
      background-repeat: no-repeat;
      background-position: left 15px center;
      background-size: auto 20px;
      transition: all 0.15s linear;
      padding: 1em 1em 1em 3em;
      cursor: pointer;

      &.icon-home {
        background-image: url('/static/img/assets/sidebar/home.svg');
      }

      &.icon-greeting {
        background-image: url('/static/img/assets/sidebar/greeting.svg');
      }

      &.icon-speech {
        background-image: url('/static/img/assets/sidebar/speech.svg');
      }

      &.icon-mailbox {
        background-image: url('/static/img/assets/sidebar/mailbox.svg');
      }

      &.icon-analytics {
        background-image: url('/static/img/assets/sidebar/analytics.svg');
      }

      &.icon-billing {
        background-image: url('/static/img/assets/sidebar/billing.svg');
      }

      &.icon-setting {
        background-image: url('/static/img/assets/sidebar/setting.svg');
      }

      &.icon-gym {
        background-image: url('/static/img/assets/sidebar/gym.svg');
      }

      &.icon-help {
        background-image: url('/static/img/assets/sidebar/help.svg');
      }

      &.icon-megaphone {
        background-image: url('/static/img/assets/sidebar/megaphone.svg');
      }

      &.icon-premium {
        background-image: url('/static/img/assets/sidebar/premium.svg');
      }

      &.icon-shop {
        background-image: url('/static/img/assets/sidebar/shop.svg');
      }

      &.icon-sign-out {
        background-image: url('/static/img/assets/sidebar/sign-out.svg');
      }

      &.icon-plugin {
        background-image: url('/static/img/assets/sidebar/plugin.svg');
      }

      &.icon-flow {
        background-image: url('/static/img/assets/sidebar/flow.svg');
      }

      span {
        width: 100%;
        color: white;
        margin-left: 10px;
      }

      &:hover {
        background-color: rgba(0, 0, 0, 0.1);
      }
    }

    .devide {
      border-bottom: 1px solid #ff8c88;
    }
  }
}

.myCustomClass {
  position: absolute;
  z-index: 3;
  right: 10px;
  top: 10px;
  opacity: 0.9;

  .flash__message-content,
  .flash__close-button {
    color: white;
  }
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/Main.vue